import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateHoliday = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const formik = useFormik({
        initialValues: {
            date: initialData?.date || '',
            reason: initialData?.reason || '',
        },
        validationSchema: Yup.object({
            date: Yup.string()
                .required('Holiday Date is required')
                .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in the format YYYY-MM-DD'),
            reason: Yup.string().required('Reason is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            if (initialData?.date) {
                onSubmit({
                    sp: 'usp_UpdateHoliday',
                    date: values?.date,
                    reason: values?.reason,
                    holidayId: initialData?.holidayId,
                });
                onClose();
            } else {
                onSubmit({
                    sp: 'usp_InsertHoliday',
                    date: values?.date,
                    reason: values?.reason,
                });
                onClose();
            }
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    useEffect(() => {
        if (initialData?.date) {
            formik.setFieldValue('date', initialData?.date);
        }
        if (initialData?.reason) {
            formik.setFieldValue('reason', initialData?.reason);
        }
    }, [initialData]);

    return (
        <Modal
            title={initialData ? 'Edit Holiday' : 'Create New Holiday'}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600} // Adjust modal width
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <label className="form-label fs-7 text-light-emphasi">
                                Holiday Date
                            </label> <span className='text-danger'>*</span>
                            <input
                                type="date"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                name="date"
                                value={formik.values.date}
                                onChange={formik.handleChange}
                                min={new Date().toISOString().split('T')[0]}
                                max="9999-12-31" // Optional: To limit the max date format
                            />
                            <span style={{ color: 'red' }} role="alert">{formik.errors.date}</span>
                        </div>

                        <div className="col-md-12 mt-3">
                            <label className="form-label fs-7 text-light-emphasi">
                                Reason
                            </label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter reason"
                                name="reason"
                                value={formik.values.reason}
                                onChange={formik.handleChange}
                            />
                            <span style={{ color: 'red' }} role="alert">{formik.errors.reason}</span>
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? 'Update' : 'Add'}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

// CreateHoliday.propTypes = {
//     visible: PropTypes.bool.isRequired,
//     handleClose: PropTypes.func.isRequired,
//     initialData: PropTypes.shape({
//         date: PropTypes.string,
//         reason: PropTypes.string,
//     }),
//     onSubmit: PropTypes.func.isRequired,
// };

export default CreateHoliday;
